import { render, staticRenderFns } from "./Hipaa.vue?vue&type=template&id=b0e51fc0"
import script from "./Hipaa.vue?vue&type=script&lang=js"
export * from "./Hipaa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports